import React from 'react';
import SqLoading from 'components/SqLoading';

const GlobalLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <SqLoading />
    </div>
  );
};

export default GlobalLoader;
